<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Empresas
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12)
        v-card(color='', style="border-radius:5px;background-color: black;height:80px")
            v-card-title.justify-center
              img(src='../assets/logo3.png', with='50' ,height='50')
        v-card(color='', style="border-radius:5px;background-color: #d6d6d6")
            v-card-title(style="padding: 7px;").justify-center
                span.black--text  Administración de Empresas
        v-btn.mb-2(@click="dialog = true" style="border-radius:5px;background-color: black;") Nueva Empresa
    v-dialog(v-model='dialog2', persistent max-width='400px')
        v-container(style='background-color:white !important;max-width: 400px;')
            v-card-title.justify-center
                span.headline Empresa
            div(style="margin-top: 20px;")
                v-flex(xs12 sm12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12)
                          v-form(enctype="multipart/form-data")

                            v-text-field(outline
                            type='number'
                            min='0'
                            v-model="rennw.mensajesA"
                            prepend-inner-icon="description"
                            label="Mensajes a asignar:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-btn(style="background:grey;border-radius:10px;", @click.native='renovarSMS') Guardar
                                  v-btn(style="background:black;border-radius:10px;", @click.native='close2') Salir

    v-dialog(v-model='dialog', persistent max-width='700px')
        v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Empresa
            div(style="margin-top: 20px;")
                v-flex(xs12 sm12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs6)
                          v-form(enctype="multipart/form-data")

                            v-text-field(outline
                            v-model="form.nombre"
                            prepend-inner-icon="description"
                            label="Nombre:")

                            v-text-field(outline
                            v-model="form.email"
                            prepend-inner-icon="description"
                            label="Correo:")

                            v-text-field(outline
                            type='number'
                            min='0'
                            :disabled='comparar()'
                            v-model="form.mensajesA"
                            prepend-inner-icon="description"
                            label="Mensajes a asignar:")

                            v-text-field(outline
                            v-model="form.usuario"
                            prepend-inner-icon="description"
                            label="Usuario:")

                            v-text-field(outline
                            required
                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                            v-model="form.password"
                            prepend-inner-icon="lock"
                            label="Contraseña:")

                            v-switch(v-model='form.renovacion' label="Renovación automática")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-btn(style="background:grey;border-radius:10px;", @click.native='save') Guardar
                                  v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir

    v-text-field(v-model='search', append-icon='search', label='Buscar' style='width:50%;')
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Empresas
        v-data-table.elevation-1(:headers='headers', :search='search', :items="empresas", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item._id }}
            td {{ props.item.nombre }}
            td {{ props.item.mensajesA }}
            td {{ props.item.mensajes }}
            td {{ props.item.fechaCorte | moment('DD-MM-YYYY') }}
            td 
              v-switch(v-model='props.item.estatus' @change='actu(props.item)' style='padding-top: 20px;')
            td(style='margin-top:20px;').justify-start.layout.px-0
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mx-2(@click='editItem(props.item)' color='teal' v-on="on") edit
                | Editar
              v-tooltip(bottom v-if='props.item.mensajesA === props.item.mensajes || comprarFecha(props.item.fechaCorte)')
                template(v-slot:activator='{ on }')
                  v-icon.mx-2(@click='editItem2(props.item)' color='black' v-on="on") autorenew
                | Renovar
              //- v-tooltip(bottom)
              //-   template(v-slot:activator='{ on }')
              //-     v-icon.mx-0(@click='deleteItem(props.item)' color='red' v-on="on") delete
              //-   | Eliminar
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mEmpresas",
  data: () => ({
    search: "",
    ruta: server + ":" + port,
    rennw: {
      _id: "",
      mensajesA: 0,
      fechaCorte: new Date(),
      mensajes: 0
    },
    defaultRennw: {
      _id: "",
      mensajesA: 0,
      fechaCorte: new Date(),
      mensajes: 0
    },
    form: {
      nombre: "",
      usuario: "",
      mensajesA: 0,
      email: "",
      renovacion: false,
      fechaCorte: new Date(),
      password: ""
    },
    dialog: false,
    dialog2: false,
    editedIndex: -1,
    show1: false,
    loading: false,
    empresas: [],
    headers: [
      { text: "Token", value: "_id" },
      { text: "Nombre", value: "nombre" },
      { text: "Mensajes asignados", value: "mensajesA" },
      { text: "Mensajes enviados", value: "mensajes" },
      { text: "Fecha de corte", value: "fechaCorte" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
      nombre: "",
      usuario: "",
      email: "",
      renovacion: false,
      mensajesA: 0,
      fechaCorte: new Date(),
      password: ""
    }
  }),
  created() {
    this.initialize();
  },
  methods: {
    comprarFecha(item) {
      return this.$moment(item).isSameOrBefore(new Date());
    },
    actu(item) {
      let info = {
        _id: item._id,
        estatus: item.estatus
      };
      Api.put("empresa", info).then(res => {
        this.$swal.fire({
          position: "top-end",
          type: "success",
          title: "Modificación realizada exitosamente.",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },
    comparar() {
      if (this.editedIndex === -1) {
        return false;
      } else {
        return true;
      }
    },
    initialize() {
      this.editedIndex = -1;
      Api.get("empresa").then(res => {
        this.empresas = res.data;
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.editedIndex = -1;
      this.dialog = false;
      this.initialize();
    },
    close2() {
      this.rennw = Object.assign({}, this.defaultRennw);
      this.editedIndex = -1;
      this.dialog2 = false;
      this.initialize();
    },
    renovarSMS() {
      if (this.rennw.mensajesA && this.rennw.mensajesA > 0) {
        this.loading = true;
        let fecha = new Date();
        this.rennw.fechaCorte = fecha.setMonth(fecha.getMonth() + 1);
        Api.put("empresa", this.rennw)
          .then(res => {
            if (res.data.message) {
              this.$swal.fire("Error encontrado", res.data.message, "error");
              this.loading = false;
            } else {
              this.loading = false;
              this.rennw = Object.assign({}, this.defaultRennw);
              this.dialog2 = false;
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              this.initialize();
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
          });
      } else {
        this.$swal.fire(
          "Error encontrado",
          "Estimado usuario, debe ingresar una cantidad valida para los mensajes asignados.",
          "error"
        );
      }
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!"
        })
        .then(result => {
          if (result.value) {
            Api.delete("empresa/" + item._id)
              .then(res => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
    },
    editItem(item) {
      this.editedIndex = this.empresas.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    editItem2(item) {
      this.rennw._id = item._id;
      this.dialog2 = true;
    },
    save() {
      if (
        this.form.nombre &&
        this.form.usuario &&
        this.form.mensajesA &&
        this.form.mensajesA > 0 &&
        this.form.password &&
        this.form.email
      ) {
        this.loading = true;
        this.form.usuario = this.form.usuario.toLowerCase();
        if (this.editedIndex > -1) {
          Api.put("empresa", this.form)
            .then(res => {
              if (res.data.message) {
                this.$swal.fire("Error encontrado", res.data.message, "error");
                this.loading = false;
              } else {
                this.loading = false;
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        } else {
          let fecha = new Date();
          this.form.fechaCorte = fecha.setMonth(fecha.getMonth() + 1);
          Api.post("empresa", this.form)
            .then(res => {
              if (res.data.message) {
                this.loading = false;
                this.$swal.fire("Error encontrado", res.data.message, "error");
              } else {
                this.loading = false;
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Registro realizada exitosamente.",
                  "success"
                );
                this.initialize();
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        }
      } else {
        this.$swal.fire(
          "Oops...",
          "Error encontrado, para realizar el registro no debe dejar campos vacios.",
          "error"
        );
      }
    }
  }
};
</script>
